import { https } from "../http";
import store from "../store";
import {
  setCancelSkaiLoading,
  setLoading,
  setSkaiLoading,
  setSkaiTokenUsage,
  setTokenPackages,
} from "../store/reducers/skaiSlice";
import { showError } from "../utils";

// get skai token usage
export const getSkaiTokenUsage = async (id, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));

    const response = await https().get(`/skai/tokens-usage/${id}`);

    if (response?.status === 200) {
      store.dispatch(setSkaiTokenUsage(response?.data));
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return error
  } finally {
    if (showLoading) store.dispatch(setLoading(false));
  }
};

// purchase skai tokens
export const purchaseSkaiTokens = async (payload, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));

    const response = await https().post("/skai/tokens-purchase", payload);

    if (response?.status === 200) {
      return response;
    } else {
      showError(response?.data?.message || "Token purchase failed");
    }
  } catch (error) {
    showError(
      error?.response?.data?.message || "An error occurred during purchase"
    );
    throw error;
  } finally {
    if (showLoading) store.dispatch(setLoading(false));
  }
};

export const cancelAiSubscription = async (data, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setCancelSkaiLoading(true));
    let response = await https().post("/skai/ai-cancel-subscription", data);

    if (response?.status === 200) {
      // getSkaiTokenUsage(data?._id, false);
      store.dispatch(setCancelSkaiLoading(false));
      return response;
    }
  } catch (error) {
    store.dispatch(setCancelSkaiLoading(false));
    showError(error?.response?.data?.message, 500);
    return error;
  }
};

// update skai token purchase
export const updateSkaiTokenPurchase = async (id, data, adminId ,showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));

    const response = await https().put(`/skai/tokens-purchase/${id}`, data);

    if (response?.status === 200) {
      store.dispatch(setSkaiTokenUsage(response?.data?.record)); // Or update a relevant store slice
      getSkaiTokenUsage(adminId, false);
      return response;
    }
  } catch (error) {
    showError(
      error?.response?.data?.message || "Failed to update token purchase",
      error?.response?.status
    );
  } finally {
    if (showLoading) store.dispatch(setLoading(false));
  }
};

// get skai token packages
export const getSkaiTokenPackages = async (showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setSkaiLoading(true));

    const response = await https().get("/skai/get-token-packages");

    if (response?.status === 200) {
      store.dispatch(setTokenPackages(response.data?.packages));
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  } finally {
    if (showLoading) store.dispatch(setSkaiLoading(false));
  }
};
